export var AiReportFormMutationTypes;
(function (AiReportFormMutationTypes) {
    AiReportFormMutationTypes["INIT_STATE"] = "INIT_STATE";
    AiReportFormMutationTypes["ADD_IDS"] = "ADD_IDS";
    AiReportFormMutationTypes["REMOVE_IDS"] = "REMOVE_IDS";
    AiReportFormMutationTypes["SET_VIEW_LARGE_PROCESS"] = "SET_VIEW_LARGE_PROCESS";
})(AiReportFormMutationTypes || (AiReportFormMutationTypes = {}));
